import ProcessPrioritizationMatrix from "./process/ProcessPrioritizationMatrix";
import CombinedProcessDetails from "./process/CombinedProcessDetails";
const ProcessDeepDive = ({ data }) => {
    return (<div className="space-y-6">
      <ProcessPrioritizationMatrix analysis={data.process_analysis}/>
      <CombinedProcessDetails analysis={data.process_analysis} uniqueId={data.unique_id}/>
    </div>);
};
export default ProcessDeepDive;
